// ─────────────────────────────────────────────
// EpisodesPage.jsx
// ─────────────────────────────────────────────
import React, { useState } from "react";
import EpisodeCard from "../../components/public/EpisodeCard";

export default function EpisodesPage({ episodes, setModal }) {
  const [filter, setFilter] = useState("All");
  const topics   = ["All", ...new Set(episodes.map((e) => e.topic).filter(Boolean))];
  const filtered = filter === "All" ? episodes : episodes.filter((e) => e.topic === filter);

  return (
    <section style={{ padding: "5rem 2rem" }}>
      <div style={{ maxWidth: 1200, margin: "0 auto" }}>
        <div className="section-label">Archive</div>
        <h2 className="section-title">All Episodes</h2>

        {topics.length > 1 && (
          <div style={{ display: "flex", gap: "0.75rem", flexWrap: "wrap", marginBottom: "2rem" }}>
            {topics.map((t) => (
              <button key={t} onClick={() => setFilter(t)} className={`filter-btn ${filter === t ? "active" : ""}`}>{t}</button>
            ))}
          </div>
        )}

        {filtered.length === 0 ? (
          <div className="empty-state"><div className="empty-icon">🎙</div><p>No episodes yet.</p></div>
        ) : (
          <div className="card-grid">
            {filtered.map((ep) => <EpisodeCard key={ep.id} episode={ep} onClick={() => setModal(ep)} />)}
          </div>
        )}
      </div>
    </section>
  );
}
